import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getTypeServices } from '../thunks/servicesThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearServicesKey } from '../thunkKeys/servicesThunksKeys';

const SLICE_NAME = 'typeServices';

export const typeServicesSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearTypeServices(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getTypeServices });
        builder.addCase(
            clearServicesKey,
            () => commonInitialState,
        );
    },
});

export const { clearTypeServices } = typeServicesSlice.actions;

export const typeServices = typeServicesSlice.reducer;
